<template>
  <div>
    <div class="text-center titles font-weight-bold">
      სერვისის სახე
    </div>
    <div class="text-center small text-danger" v-if="$v.service.$error">გთხოვთ აირჩიოთ სერვისი</div>
    <b-card class="mt-3" v-for="(serv,index) in services.serviceList" :key="index" @click="service=serv.publicId; selectedService=serv">
      <b-form-radio  name="some-radios1" v-model="service" :value="serv.publicId" class="NotoSansGeorgian-Regular">
        {{serv.name}}
      </b-form-radio>
    </b-card>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
export default {
  name: "step-4",
  props:['services'],
  data(){
    return {
      service:null,
      selectedService:{}
    }
  },
  validations:{ service:{required} },
  mounted(){
    this.service=this.services.serviceList[0].publicId;
    this.selectedService=this.services.serviceList[0];
  }
}
</script>

<style scoped>
.card{
  border-radius: 10px !important;
  box-shadow:  0 0 3px #899BB1;
}
.NotoSansGeorgian-Regular{
  font-size: 14px !important;
}
</style>